import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const Chips = ({ options, value, onPick, prefix }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map(([k, l]) => <button key={k} onClick={() => onPick(k)} data-testid={`${prefix}-${k}`} className={`px-3 py-1 rounded-full text-xs border transition-colors ${value === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-600 hover:bg-slate-50"}`}>{l}</button>)}
  </div>
);

export function MakeMoreDialog({ meta, platform, onClose, onQueued }) {
  const formats = Object.entries(meta.formats).filter(([, f]) => f.platform === platform);
  const [format, setFormat] = useState(formats[0][0]);
  const [audience, setAudience] = useState("owners");
  const [count, setCount] = useState(2);
  const [busy, setBusy] = useState(false);
  const go = () => {
    setBusy(true);
    api.post("/admin/content/more", { format, audience, count }).then(() => { toast.success("Writing new ads — they'll appear in about a minute"); onQueued(); onClose(); })
      .catch((e) => toast.error(formatErr(e))).finally(() => setBusy(false));
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="make-more-dialog">
        <DialogHeader><DialogTitle>Make more {meta.platforms[platform]} ads</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm">
          <div><div className="text-xs font-semibold text-slate-600 mb-1.5">Format</div><Chips options={formats.map(([k, f]) => [k, f.label])} value={format} onPick={setFormat} prefix="more-format" /></div>
          <div><div className="text-xs font-semibold text-slate-600 mb-1.5">Speaks to</div><Chips options={Object.entries(meta.audiences)} value={audience} onPick={setAudience} prefix="more-audience" /></div>
          <div><div className="text-xs font-semibold text-slate-600 mb-1.5">How many new ideas</div><Chips options={[[1, "1"], [2, "2"], [3, "3"], [4, "4"]]} value={count} onPick={setCount} prefix="more-count" /></div>
          <p className="text-xs text-slate-500">Each idea comes in English and Spanish. Images and videos are made when you tap "Make" on a card.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={go} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="make-more-submit">Write ads</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
